<template>
  <div :class="bem.b()">
    <!-- input组合 -->
    <search
      v-bind="attrs"
      v-model:value="iconValue"
      :readonly="props.readonly"
      :show-icon-only="showIconOnly"
      :size="size"
      @handle-modal="handleModalVisible"
      @change="handleChangeValue"
    />

    <!-- icon弹窗 -->
    <modal
      v-model:open="open"
      v-model:value="iconValue"
      :data="iconList || data.glyphs"
      @change-icon-value="handleChangeValue"
    />
  </div>
</template>
<script lang="ts" setup>
import { ref, useAttrs, watch } from 'vue'

// @ts-ignore
import data from '@ll-plus/theme-chalk/src/fonts/iconfont.json'
import { createNamespace } from '@ll-plus/utils'

import modal from './components/modal.vue'
import search from './components/search.vue'

import { iconPickerProps } from './config/icon-picker'

// 1.defineOptions
defineOptions({
  name: 'LlIconPicker',
})

// 2.props
const props = defineProps(iconPickerProps)
const emits = defineEmits(['update:value'])

// 3.hooks
const attrs = useAttrs() // 传递给input的额外属性

// 4.ref/const
const iconValue = ref('')
const open = ref(false)
const bem = createNamespace('icon-picker')

// 5.methods
const handleModalVisible = (bool: boolean) => (open.value = bool)

const handleChangeValue = (value: string) => {
  emits('update:value', value)
  iconValue.value = value
}

// 6.watch
watch(
  () => props.value,
  (newValue) => {
    iconValue.value = newValue || ''
  },
  { immediate: true }
)

defineExpose({
  handleModalVisible,
})
</script>
